export const FILE_REFERENCE_TYPES = {
    PERSON: 'Person',
    FAMILY_ASSISTANCE: 'FamilyAssistance',
    TENANT: 'Tenant',
    RESPONDER: 'Responder'
} as const;

export const FILE_KINDS = {
    PERSONAL_IMAGE: 'PersonalImage',
    LICENSE_ID: 'LicenseId',
    TATTOO: 'Tattoo',
    SCAR: 'Scar',
    FAMILY_ASSISTANCE: 'FamilyAssistance',
    LOGO: 'Logo'
} as const;

export type FileReferenceType = typeof FILE_REFERENCE_TYPES[keyof typeof FILE_REFERENCE_TYPES];
export type FileKind = typeof FILE_KINDS[keyof typeof FILE_KINDS];
